export default __webpack_public_path__ + "static/media/joel.8c6cc482.png";